<template>
  <div>
    <v-checkbox
      v-model="dealer.isCopyNotifications"
      :label="$t('dealer.edit.copyNotifications')"
      tabindex="1"
      @change="onCopyNotificationsChange"
    ></v-checkbox>

    <div v-if="dealer.isCopyNotifications">
      <div
        v-for="(email, index) in dealer.copyNotificationsEmailAddresses"
        :key="'copy-email-' + index"
        class="d-flex align-start"
      >
        <v-text-field
          v-model.trim="dealer.copyNotificationsEmailAddresses[index]"
          :rules="emailRules"
          :label="$t('dealer.edit.copyNotificationsEmail')"
          type="email"
          autocomplete="off"
          validate-on-blur
          tabindex="1"
          class="copy-email-field mr-1"
        ></v-text-field>
        <d-btn-icon
          type="delete"
          btn-class="mt-3"
          @click="removeCopyEmail(index)"
        ></d-btn-icon>
      </div>

      <v-btn
        text
        small
        color="primary"
        class="px-0 mb-2"
        @click="addCopyEmail"
      >
        {{ $t('dealer.edit.addCopyNotificationsEmail') }}
      </v-btn>

      <v-text-field
        :value="copyEmailsJoined"
        :rules="listRules"
        class="copy-emails-rule"
        readonly
        hide-details="auto"
      ></v-text-field>
    </div>
  </div>
</template>


<script>
import { dealerSchema } from '@/constants'
import { normalizeCopyNotificationsEmails } from '@/utils/copyNotifications.util'

import validationMixin from '@/mixins/validation.mixin'

import DBtnIcon from '@/components/DBtnIcon'


export default {
  props: {
    dealer: {
      type: Object,
      required: true
    }
  },


  components: {
    DBtnIcon
  },


  mixins: [
    validationMixin
  ],


  computed: {
    emailRules () {
      return [
        this.rule.required(),
        this.rule.email()
      ]
    },

    listRules () {
      const max = dealerSchema.copyNotificationsEmailsMaxLength

      return [
        () => {
          const emails = this.dealer.copyNotificationsEmailAddresses || []
          if (!emails.length) {
            return this.$t('dealer.edit.copyNotificationsEmailsRequired')
          }

          const joined = normalizeCopyNotificationsEmails(emails).join(';')
          return joined.length <= max || this.$t('validation.maxLengthString', { max })
        }
      ]
    },

    copyEmailsJoined () {
      return normalizeCopyNotificationsEmails(this.dealer.copyNotificationsEmailAddresses).join(';')
    }
  },


  methods: {
    onCopyNotificationsChange (enabled) {
      this.ensureEmailsArray()

      if (enabled) {
        if (!this.dealer.copyNotificationsEmailAddresses.length) {
          this.dealer.copyNotificationsEmailAddresses.push('')
        }
        return
      }

      const filled = this.dealer.copyNotificationsEmailAddresses.filter(email => String(email || '').trim())
      this.dealer.copyNotificationsEmailAddresses.splice(0, this.dealer.copyNotificationsEmailAddresses.length, ...filled)
    },

    addCopyEmail () {
      this.ensureEmailsArray()
      this.dealer.copyNotificationsEmailAddresses.push('')
    },

    removeCopyEmail (index) {
      this.dealer.copyNotificationsEmailAddresses.splice(index, 1)
    },

    ensureEmailsArray () {
      if (!Array.isArray(this.dealer.copyNotificationsEmailAddresses)) {
        this.$set(this.dealer, 'copyNotificationsEmailAddresses', [])
      }
    }
  }
}
</script>


<style scoped>
.copy-emails-rule >>> .v-input__slot {
  display: none;
}

.copy-email-field >>> input:-webkit-autofill,
.copy-email-field >>> input:-webkit-autofill:hover,
.copy-email-field >>> input:-webkit-autofill:focus,
.copy-email-field >>> input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px #fff inset;
  box-shadow: 0 0 0 1000px #fff inset;
  -webkit-text-fill-color: #212121;
  caret-color: #212121;
  transition: background-color 9999s ease-out;
}
</style>
